<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="avaliacoes"
      :sort-by="[{ key: 'id', order: 'asc' }]"
      :search="search"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar flat>
          <v-btn
            style="background: #f9f8f8; font-size: 18px"
            size="small"
            @click="this.$router.push('/projects')"
            icon
          >
            <v-icon color="#004984">mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >{{ nomeProjeto }} - Avaliações</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            outline
            hide-details
            variant="underlined"
          ></v-text-field>

          <!-- <CreateRating
            style="margin-right: 40px"
            :idProjeto="parseInt(this.$route.params.id)"
          /> -->

          <v-dialog v-model="editarDialog" max-width="600px">
            <v-card height="700px">
              <v-card-title>
                <span class="text-h5">Editar Avaliação</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.titulo"
                        variant="underlined"
                        label="Título"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <p>Começo da Avaliação</p>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                      <p>Fim da Avaliação</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <VueDatePicker
                        v-model="editedItem.dataInicio"
                        auto-apply
                        :min-date="new Date()"
                        :enable-time-picker="false"
                        :format="
                          editedItem.dataInicio != null
                            ? format(editedItem.dataInicio)
                            : ''
                        "
                      ></VueDatePicker>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <VueDatePicker
                        v-model="editedItem.dataFim"
                        auto-apply
                        :min-date="editedItem.dataInicio"
                        :enable-time-picker="false"
                        :format="
                          editedItem.dataFim != null
                            ? format(editedItem.dataFim)
                            : ''
                        "
                      ></VueDatePicker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" variant="text" @click="editarDialog = false">
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="editarAvaliacao(editedItem)"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--Excluir avaliação-->
          <v-dialog v-model="excluirDialog" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Excluir Avaliação</v-card-title>
              <v-card-text>
                <p>Deseja realmente excluir esta avaliação?</p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  variant="text"
                  @click="this.excluirDialog = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="deleteItemConfirm"
                  >Confirmar</v-btn
                >
                <!-- <v-spacer></v-spacer> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- eslint-disable -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip text="Editar Avaliação" location="bottom">
          <template #activator="{ props }">
            <v-icon v-bind="props" size="small" @click="editItem(item.raw)">
              mdi-pencil
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip text="Excluir Avaliação" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              size="small"
              color="red"
              @click="deleteItem(item.raw)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-tooltip>
      </template>
      <!-- eslint-enable -->
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem avaliações a listar </span>
        </div>
      </template>
      <!-- <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    VueDatePicker,
    SnackBar,
  },
  data: () => ({
    dialog: false,
    excluirDialog: false,
    editarDialog: false,
    search: '',
    headers: [
      {
        title: '#',
        align: 'start',
        key: 'id',
        sortable: false,
      },
      { title: 'Titulo', key: 'titulo' },
      { title: 'Data Início', key: 'dataInicio' },
      { title: 'Data Fim', key: 'dataFim' },
      { title: 'Acões', key: 'actions', sortable: false },
    ],
    avaliacoes: [],
    editedIndex: -1,
    idItem: 0,
    editedItem: {
      id: '',
      titulo: '',
      dataInicio: new Date(),
      dataFim: new Date(),
    },
    defaultItem: {
      titulo: '',
      dataInicio: new Date(),
      dataFim: new Date(),
    },
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    excluirDialog(val) {
      val || this.closeDelete();
    },
    editarDialog(val) {
      val || this.editarDialog === false;
    },
  },

  created() {
    this.idAvaliacao = this.$route.params.id;
    this.nomeProjeto = this.$route.params.nome;
    this.fetchavaliacoes();
  },

  methods: {
    // Função de inicialização de projeto, sempre preenche com uma req ao back
    /* eslint-disable */
    /**
     * Busca a lista de avaliações a partir do backend e preenche o array de projetos
     * @function
     * @name fetchavaliacoes
     * @memberof RatingsList
     * @returns {Promise<void>}
     */
    fetchavaliacoes() {
      axios
        .get(API_URL + `/avaliacoes/${this.idAvaliacao}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          let count = 1;
          response.data.forEach((element) => {
            /* eslint-disable */
            element.fl_coordenador === true
              ? (element.fl_coordenador = 'Coordenador')
              : (element.fl_coordenador = 'Desenvolvedor');
            /* eslint-enable */

            const dtinicio = new Date(element.tb_avaliacao.dtinicio);
            const dtfim = new Date(element.tb_avaliacao.dtfim);

            this.avaliacoes.push({
              id: count++,
              idAval: element.tb_avaliacao.id_avaliacao,
              titulo: element.tb_avaliacao.titulo,
              dataInicio: `${dtinicio.getDate()}/${
                dtinicio.getMonth() + 1
              }/${dtinicio.getFullYear()}`,
              dataFim: `${dtfim.getDate()}/${
                dtfim.getMonth() + 1
              }/${dtfim.getFullYear()}`,
              dataIniSemFormatar: dtinicio,
              dataFimSemFormatar: dtfim,
              idproj: element.id_projeto,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    /* eslint-disable */

    /**
     * Atualiza o estado de um item selecionado para ser editado e abre um diálogo para exibir as informações do item. Também faz uma requisição para obter os membros da equipe do item selecionado.
     *
     * @function showItem
     * @param {object} item - O objeto do item selecionado.
     * @returns {void}
     */
    showItem(item) {
      this.editedIndex = this.avaliacoes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.idProjeto = item.idproj;
      this.fetchEquipe(item.idEquipe);
    },

    editItem(item) {
      this.editedIndex = this.avaliacoes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.titulo = item.titulo;
      this.editedItem.dataInicio = item.dataIniSemFormatar;
      this.editedItem.dataFim = item.dataFimSemFormatar;
      this.editedItem.id = item.idAval;
      this.editarDialog = true;
    },

    editarAvaliacao(item) {
      const data = {
        titulo: item.titulo,
        dtinicio: item.dataInicio,
        dtfim: item.dataFim,
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      if (
        item.titulo != '' &&
        item.dataInicio != null &&
        item.dataFim != null
      ) {
        axios
          .put(API_URL + `/avaliacoes/${item.id}`, data, config)
          .then((response) => {
            console.log(response.data);
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Avaliação editada com sucesso!'
            );
            location.reload();
          })
          .catch((error) => {
            console.error(error);
            console.log(item.descricao);
            this.$refs.snackbar.showErrorSnackbar(
              'Uhm! Por algum motivo não conseguimos editar a avaliação'
            );
          });
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Campos vazios!',
          'Por favor, preencha todos os campos obrigatórios!'
        );
      }
    },

    deleteItem(item) {
      this.editedIndex = this.avaliacoes.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // chamar rota de excluir item de avaliação aqui
      this.idItem = item.idAval;
      this.excluirDialog = true;
    },

    deleteItemConfirm() {
      axios
        .delete(API_URL + `/avaliacoes/${this.idItem}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then(() => {
          this.avaliacoes.splice(this.editedIndex, 1);
          this.closeDelete();
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Avaliação excluída com sucesso!'
          );
        })
        .catch((error) => {
          this.$refs.snackbar.showErrorSnackbar(
            'Erro!',
            error.response.data.error
          );
          console.error(error);
        });
    },

    closeDelete() {
      this.excluirDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    /**
     * Fecha o diálogo de visualizar de item e reseta o estado do item editado e da lista de membros da equipe.
     *
     * @function close
     * @returns {void}
     */
    close() {
      this.dialog = false;
    },

    format(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style scoped>
.d-flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
</style>
